/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import DeleteRecordButton from "../input/DeleteRecordButton";
import { useTranslation } from "react-i18next";
import { useEffect, useMemo, useState } from 'react';
import { debounce } from "lodash";
import "../grid/layout/DataGridMomSysSafetyStockInventoryStateColumn.css"
import TkCreateWireCamButton from "../input/TkCreateWireCamButton";
import getSchema from "../../lib/api/getSchema";
import { getProcessName, settingHideProcessShcema } from "../../lib/TkPopUtils/TkPopProductMangeDetailUtils";
import AccessControl from "../functional/AccessControl";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import TkPopProductManageDetailCAMButton from "../input/TkPopProductManageDetailCAMButton";
import TkPopProductManageDetailCommonUpdate from "../input/TkPopProductManageDetailCommonUpdate";
import TkPopProductManageDetailCommonCreate from "../input/TkPopProductManageDetailCommonCreate";
import TkUpdateWireCamButton from "../input/TkUpdateWireCamButton";
import TkPopElectrodeCreateButton from './../input/TkPopElectrodeCreateButton';
import TkCreateWireSuperDrillButton from "../input/TkCreateWireCamSuperDrilButton";
import TkUpdateWireSuperDrillButton from "../input/TkUpdateWireSuperDrillButton";
import TkPopWrappingCreateButton from "../input/TkPopWrappingCreateButton";
import TkPopWrappingUpdateButton from "../input/TkPopWrappingUpdateButton";

function TkPopProductManageDetail(props) {
    const {
        id,
        idDetail,
        view,
        detailApiInitialized,
        onSelectMst,
        onMstEmpty,
    } = props;

    const { t } = useTranslation();

    const [api, setApi] = useState();

    const [grid, setGrid] = useState();

    const [isEmpty, setIsEmpty] = useState();

    const [shcemaPerProcess, setShcemaPerProcess] = useState();

    const [detailSeletMst, setDetailSeletMst] = useState();
    const [isacquisition, setIsacquisition] = useState();
    const [isFinish, setIsFinish] = useState();
    const [isMeasurement, setIsMeasurement] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect(() => {

        if (api) {

            api.refresh();

        }

    }, [onSelectMst.planId])

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.loadedRows.addHandler(debounce((flex, event) => {

                    for (let row of flex.rows) {

                        if (row.dataItem.processCode === onSelectMst.processCode) {

                            row.cssClass = `safeStock-many-qty`;

                        } else if (row.dataItem.processCode === "CAM" && onSelectMst.processCode === "PR008") {

                            row.cssClass = `safeStock-many-qty`;

                        } else {

                            row.cssClass = null;

                        }

                    }

                }), 10);

            }

        })()

    }, [grid, onSelectMst]);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setDetailSeletMst(grid.selectedItems[0])

                    } else {

                        setDetailSeletMst([])

                    }

                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        setDetailSeletMst(grid.selectedItems[0])

                    } else {

                        setDetailSeletMst([])

                    }

                }), 10);

            }

        })()

    }, [grid]);

    useEffect(() => {

        if (detailSeletMst?.processName) {
            if (detailSeletMst?.processName.includes("소재인수")) { // 수정만 가능
                setIsacquisition(true);
            } else {
                setIsacquisition(false)
            }

            if (detailSeletMst?.processName.includes("작업종료")) { // 수정 삭제 불가능
                let bool = true;
                if (detailSeletMst?.processName.includes("측정")) {
                    bool = false;
                }
                setIsFinish(bool)
            } else {
                setIsFinish(false)
            }

            if (detailSeletMst?.processName.includes("측정")) {
                setIsMeasurement(true); // 측정인 경우 소재인수와 동일하게 수정만 가능
            } else {
                setIsMeasurement(false)
            }
        }
    }, [detailSeletMst?.processName])


    const unavailable = useMemo(() => {

        if (detailSeletMst?.processCode) {

            if (id === getProcessName(detailSeletMst?.processCode)) {

                return false;

            }

        }

        return true;

    }, [detailSeletMst?.processCode, id])

    useEffect(() => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("TkPopProductManageDetail");

            if (mounted) {

                schema = settingHideProcessShcema(id, schema);

                schema.columns.push({
                    name: "workers",
                    formOrder: 315,
                    hideInForm: false,
                    formGroup: 0,
                    formItemType: "multipleAutocomplete",

                    codeInfo: {
                        tableName: "User",
                        nameColumn: ["fullName"],
                        valueColumn: "username",
                        useEmptyValue: false,
                        sortByName: true,
                    }
                })

                setShcemaPerProcess(schema);

            }

        })();

        return (() => {

            mounted = false;

        });

    }, [id]);

    const onInitialized = (grid) => {

        grid.selectionMode = "Row";

        setGrid(grid);

    }

    const onApiInitialized = (api) => {

        detailApiInitialized(api);

        setApi(api);

    };

    const onModifyViewUrl = (url, parentPlanId, index) => {

        return url + "/" + parentPlanId;

    };

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onAppendButtonInFrontOfSearch = () => {
        if (id === "PopAll") return <></>;
        return (
            <>
                <BasicCrudScreenActionItemLayout>
                    {
                        id === "Nc" ?
                            <AccessControl
                                accessTarget={shcemaPerProcess && shcemaPerProcess.name}
                                accessMethod="POST"
                            >
                                <TkPopProductManageDetailCAMButton
                                    id={id}
                                    schema={shcemaPerProcess}
                                    color="primary"
                                    createButtonName={"CAM"}
                                    onSuccess={onSuccess}
                                    refresh={api}
                                    onSelectMst={onSelectMst}
                                    disabled={onMstEmpty}
                                />
                            </AccessControl>
                            :
                            <></>
                    }

                    {
                        id === "Wire"
                            ?
                            <AccessControl
                                accessTarget={shcemaPerProcess && shcemaPerProcess.name}
                                accessMethod="POST"
                            >
                                <TkCreateWireCamButton
                                    id={id}
                                    color="primary"
                                    refresh={api}
                                    createButtonName={"wireCam"}
                                    onSelectMst={onSelectMst}
                                    onSuccess={onSuccess}
                                    disabled={onMstEmpty}
                                />
                                <TkCreateWireSuperDrillButton
                                    id={id}
                                    color="primary"
                                    refresh={api}
                                    createButtonName={"wireCamSuperDril"}
                                    onSelectMst={onSelectMst}
                                    onSuccess={onSuccess}
                                    disabled={onMstEmpty}
                                />
                            </AccessControl>
                            :
                            <></>
                    }
                    {

                        id === "Measurement" || id === "ElectrodeProcessing" || id === "Wrapping"
                            ?
                            <></>
                            :
                            <AccessControl
                                accessTarget={shcemaPerProcess && shcemaPerProcess.name}
                                accessMethod="POST"
                            >
                                <TkPopProductManageDetailCommonCreate
                                    id={id}
                                    schema={shcemaPerProcess}
                                    color="primary"
                                    onSuccess={onSuccess}
                                    refresh={api}
                                    onSelectMst={onSelectMst}
                                    detailSeletMst={detailSeletMst}
                                    disabled={onMstEmpty}
                                />
                            </AccessControl>
                    }

                    {
                        id === "ElectrodeProcessing" ?
                            <AccessControl
                                accessTarget={shcemaPerProcess && shcemaPerProcess.name}
                                accessMethod="POST"
                            >
                                <TkPopElectrodeCreateButton
                                    id={id}
                                    schema={shcemaPerProcess}
                                    grid={grid}
                                    refresh={api}
                                    color="primary"
                                    onSelectMst={onSelectMst}
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onNotifyWarning}
                                    disabled={onMstEmpty}
                                />
                            </AccessControl>
                            :
                            <></>
                    }


                    {
                        id === "Wrapping" ?
                            <AccessControl
                                accessTarget={shcemaPerProcess && shcemaPerProcess.name}
                                accessMethod="POST"
                            >
                                <TkPopWrappingCreateButton
                                    id={id}
                                    createButtonName={"WrappingCreate"}
                                    refresh={api}
                                    color="primary"
                                    onSelectMst={onSelectMst}
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onNotifyWarning}
                                    shapeType={"MPD"}
                                    disabled={onMstEmpty}
                                />
                                <TkPopWrappingCreateButton
                                    id={id}
                                    createButtonName={"WrappingVDCreate"}
                                    refresh={api}
                                    color="primary"
                                    onSelectMst={onSelectMst}
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onNotifyWarning}
                                    shapeType={"VD"}
                                    disabled={onMstEmpty}
                                />
                            </AccessControl>
                            :
                            <></>
                    }

                    <AccessControl
                        accessTarget={shcemaPerProcess && shcemaPerProcess.name}
                        accessMethod={
                            shcemaPerProcess && (shcemaPerProcess.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        {

                            id === "Wrapping" && detailSeletMst?.wpShapeType === "VD"
                                ?
                                <TkPopWrappingUpdateButton
                                    id={id}
                                    mode="edit"
                                    grid={grid}
                                    refresh={api}
                                    color="primary"
                                    detailSeletMst={detailSeletMst}
                                    processCode={detailSeletMst?.processCode}
                                    onSuccess={onSuccess}
                                    onFailure={onFailure}
                                    onPartialFailure={onNotifyWarning}
                                    shapeType={"VD"}
                                    disabled={unavailable || isEmpty || onMstEmpty}
                                />
                                :
                                id === "Wrapping" && ["MD", "PD"].includes(detailSeletMst?.wpShapeType)
                                    ?
                                    <TkPopWrappingUpdateButton
                                        id={id}
                                        mode="edit"
                                        grid={grid}
                                        refresh={api}
                                        color="primary"
                                        detailSeletMst={detailSeletMst}
                                        processCode={detailSeletMst?.processCode}
                                        onSuccess={onSuccess}
                                        onFailure={onFailure}
                                        onPartialFailure={onNotifyWarning}
                                        shapeType={"MPD"}
                                        disabled={unavailable || isEmpty || onMstEmpty}
                                    />
                                    :
                                    id === "Wire" && detailSeletMst?.processName === "CAM(WCM)"
                                        ?
                                        <TkUpdateWireCamButton
                                            id={id}
                                            grid={grid}
                                            refresh={api}
                                            onSuccess={onSuccess}
                                            processName={detailSeletMst?.processName}
                                            onSelectMst={onSelectMst}
                                            schema={shcemaPerProcess}
                                            processCode={detailSeletMst?.processCode}
                                            onSelectDetail={detailSeletMst}
                                            disabled={unavailable || isEmpty || onMstEmpty}

                                        />
                                        :
                                        id === "Wire" && detailSeletMst?.processName === "CAM(슈퍼드릴)"
                                            ?
                                            <TkUpdateWireSuperDrillButton
                                                id={id}
                                                grid={grid}
                                                refresh={api}
                                                onSuccess={onSuccess}
                                                processName={detailSeletMst?.processName}
                                                onSelectMst={onSelectMst}
                                                schema={shcemaPerProcess}
                                                processCode={detailSeletMst?.processCode}
                                                onSelectDetail={detailSeletMst}
                                                disabled={unavailable || isEmpty || onMstEmpty}
                                            />
                                            :
                                            <TkPopProductManageDetailCommonUpdate
                                                id={id}
                                                grid={grid}
                                                refresh={api}
                                                onSelectMst={onSelectMst}
                                                detailSeletMst={detailSeletMst}
                                                processCode={detailSeletMst?.processCode}
                                                processName={detailSeletMst?.processName}
                                                disabled={unavailable || isEmpty || isFinish || onMstEmpty}
                                                onSuccess={onSuccess}
                                            />
                        }

                    </AccessControl>

                    <AccessControl
                        accessTarget={shcemaPerProcess && shcemaPerProcess.name}
                        accessMethod="DELETE"
                    >
                        <DeleteRecordButton
                            id={idDetail}
                            schema={shcemaPerProcess}
                            grid={grid}
                            refresh={api}
                            color="secondary"
                            disabled={unavailable || isEmpty || isacquisition || isFinish || isMeasurement}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            onPartialFailure={onNotifyWarning}
                        />
                    </AccessControl>


                </BasicCrudScreenActionItemLayout>
            </>
        );
    };


    // const doHandleBackendErrorMsg = (reason) => {

    //     // reason.response := { data, status, statusText, headers, config, request }
    //     // data : user error message
    //     // status : http status code
    //     // statusText : http status code text
    //     const response = reason.response;
    //     return `${response.data} `;

    // };

    return (

        <BasicCrudScreenType
            id={"TkPopProductManageDetail"}
            headerTitle={t(`term.${idDetail}`)}
            view={view}
            report={view}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            onModifyViewUrl={(url) => onModifyViewUrl(url, onSelectMst.parentPlanId)}
            onModifyReportUrl={(url) => onModifyViewUrl(url, onSelectMst.parentPlanId)}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
            onLoadData={onLoadData}
            noCreate
            noEdit
            noDelete
            noExcel
            noPagination
        />

    );

}

export default TkPopProductManageDetail;
